module.exports = __webpack_public_path__ + "img/registration_at_example.7ffc053a.gif";